import type { FaireProductEntity } from "../../entity_types/product";

export const p_grrr372522: FaireProductEntity = {
  token: "p_grrr372522",
  type: "product",
  name: "Freeform Keshi Pearl Pendant Necklace (1C07NK)",
  brandName: "iBijoux",
  imageUrl:
    "https://cdn.faire.com/fastly/2c053c383d80f28c23ae4e07e1b51fa05ab2e86574c11b52cf09d0b4a3bb9642.png",
  priceDollars: 16.75,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/f880a18e8a037a53e596ead050dca0c81ae538bc4f124fc38d4b16c1a45493cd.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
